import React from "react";
import { NavLink } from "react-router-dom";

interface PatientProfileTab {
  path: string;
  label: string;
}

const patientProfileTabs: PatientProfileTab[] = [
  {
    path: "summary",
    label: "Dashboard",
  },
  {
    path: "patientinfo",
    label: "Info",
  },
  {
    path: "task",
    label: "Tasks",
  },
  {
    path: "metrics",
    label: "Metrics",
  },
  {
    path: "clinical-alerts",
    label: "Alerts",
  },
  {
    path: "care-note",
    label: "Care Notes",
  },
  {
    path: "assessments",
    label: "Assessments",
  },
  {
    path: "pgi",
    label: "PGI",
  },
  {
    path: "history",
    label: "Medications & Conditions",
  },
  // {
  //   path: "escalations",
  //   label: "Escalations",
  // },
  {
    path: "appointments",
    label: "Appointments",
  },
  {
    path: "care-plan",
    label: "Care Plan",
  },
  {
    path: "activity",
    label: "Activity",
  },
];

export const PatientProfileTabs: React.FC = () => {
  return (
    <div className="d-flex align-items-center px-4 bg-teal-light">
      <ul className="tabs flex-fill">
        {patientProfileTabs.map((tab, idx) => (
          <li className="tabs__item" key={idx}>
            <NavLink className={`tabs__link `} to={tab.path}>
              {tab.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
};
